<template>
  <section id="section_02" class="w-full min-h-screen relative flex items-center px-6">
    <div class="w-full relative justify-center text-center">
      <div
        id="section_02_content"
        class="text-white w-full flex flex-col justify-center text-center z-30 section_02_content"
      >
        <h1 class="text-xl sm:text-2xl md:text-4xl font-bold leading-tight" v-html="$t('section_intro.title')"></h1>
        <h2 class="text-lg sm:text-2xl font-book" v-html="$t('section_intro.subtitle')"></h2>
        <p class="text-base sm:text-xl mt-8" v-html="$t('section_intro.text')"></p>
        <img class="w-3/4 md:w-64 object-contain mx-auto mt-12 mb-24" src="/uploads/logo_SWMB.png" alt="Museum Logo" />
      </div>
    </div>
    <section-scroll-button
      id="scroll_prompt"
      class="z-30 absolute w-screen"
      style="bottom: 0px; left: 0px"
      :class="$device.android || $device.ios ? 'mb-32' : 'mb-8'"
      @click.native="$emit('next-section')"
    />
  </section>
</template>

<script>
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import SectionScrollButton from "../SectionScrollButton";
export default {
  components: { SectionScrollButton },
  mounted() {
    gsap.registerPlugin(ScrollTrigger);
    this.runAnimation();
  },
  methods: {
    runAnimation() {
      gsap.from("#section_02_content", {
        scrollTrigger: { trigger: "#section_02", toggleActions: "play pause resume reset" },
        opacity: 0,
        duration: 2,
        y: 100,
      });
    },
  },
};
</script>

<style lang="postcss" scoped>
</style>